import { useEffect, useState } from 'react';
import { useAuthenticationDataContext } from '../../../Helpers/AuthenticationDataProvider';
import useFetchWrapper, {
	HttpResponse,
} from '../../../Helpers/useFetchWrapper';
import { Props, Recording, TabStatus } from './RecordingsTab.model';

export const pageSize = 10;

export const useRecordingsTab = ({ filters }: Props) => {
	const [recordings, setRecordings] = useState<Recording[]>();
	const [showCreateResource, setShowCreateResource] = useState('');
	const [pagination, setPagination] = useState({
		page: 1,
		size: pageSize,
		total: 0,
	});
	const [tabStatus, setTabStatus] = useState<TabStatus>(TabStatus.Loading);
	const [pending, setPending] = useState(false);
	const [recordingToBeDeleted, setRecordingToBeDeleted] = useState('');

	const { userId, firstName, lastName } = useAuthenticationDataContext();
	const { get, remove } = useFetchWrapper();

	const getRecordings = async () => {
		setTabStatus(TabStatus.Loading);
		const queryFilters = filters && Object.keys(filters).map(key => filters[key] && `${key}=${filters[key].toISOString()}`).join('&');
		const response: HttpResponse<{ count: number; recordings: Recording[], pending: boolean }> =
			await get(`/recordings/all?${queryFilters}&page=${pagination.page}&size=${pagination.size}`);
		if (response.parsedBody) {
			const { count, pending, recordings } = response.parsedBody;
			setPending(pending);
			setRecordings(recordings);
			setPagination({ ...pagination, total: count });
			setTabStatus(TabStatus.Loaded);
		}
		else {
			setTabStatus(TabStatus.Error);
		}
	};

	const onChangePagination = (page: number) => {
		setPagination({ ...pagination, page });
	};

	const onDeleteRecordig = async () => {
		await remove(`/recording/${recordingToBeDeleted}`);
		setRecordingToBeDeleted('');
		getRecordings();
	}

	useEffect(() => {
		if (pagination.page !== 1) setPagination({ ...pagination, page: 1 });
		else getRecordings();
	}, [filters]);

	useEffect(() => {
		getRecordings();
	}, [pagination.page]);

	return {
		getRecordings,
		onChangePagination,
		onDeleteRecordig,
		setRecordingToBeDeleted,
		setShowCreateResource,
		state: {
			pagination,
			pending,
			recordingToBeDeleted,
			recordings,
			showCreateResource,
			tabStatus,
			user: {firstName, lastName, userId}
		},
	};
};
